import React from 'react';
import { LinkInner } from './skipnav.css';

const SkipNav = () => (
  <LinkInner href="#maincontent">Skip to Content (Press Enter)</LinkInner>
);

export default SkipNav;
